// @ts-nocheck
/* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-unused-vars, prettier/prettier */
import * as Types from './generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetUserTrackingDataQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetUserTrackingDataQuery = { __typename?: 'Query', userTrackingData: { __typename?: 'UserTrackingData', props: Array<{ __typename?: 'UserTrackingProp', prop: string, boolean_value?: boolean | null, string_value?: string | null, number_value?: number | null, value_prop_name: string }> } };


export const GetUserTrackingDataDocument = gql`
    query getUserTrackingData {
  userTrackingData {
    props {
      prop
      boolean_value
      string_value
      number_value
      value_prop_name
    }
  }
}
    `;

/**
 * __useGetUserTrackingDataQuery__
 *
 * To run a query within a React component, call `useGetUserTrackingDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserTrackingDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserTrackingDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserTrackingDataQuery(baseOptions?: Apollo.QueryHookOptions<GetUserTrackingDataQuery, GetUserTrackingDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserTrackingDataQuery, GetUserTrackingDataQueryVariables>(GetUserTrackingDataDocument, options);
      }
export function useGetUserTrackingDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserTrackingDataQuery, GetUserTrackingDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserTrackingDataQuery, GetUserTrackingDataQueryVariables>(GetUserTrackingDataDocument, options);
        }
export type GetUserTrackingDataQueryHookResult = ReturnType<typeof useGetUserTrackingDataQuery>;
export type GetUserTrackingDataLazyQueryHookResult = ReturnType<typeof useGetUserTrackingDataLazyQuery>;
export type GetUserTrackingDataQueryResult = Apollo.QueryResult<GetUserTrackingDataQuery, GetUserTrackingDataQueryVariables>;